import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { RouseService } from '../../rouse.service';
import { StepDialog } from './dialog-step';
import { RouseConfigService } from '../../rouse.config.service';
import { StepTypes } from '../../app.constants';


export interface StepDialogData {
  dialogTitle: string;
  dialogMode: string;

  name: string;
  type: string;
  duration: number;
  unit: string;
  cost: string;
  professional: string;
  groupName: string;
  overlapStep: boolean;

  selectionDurations: number[];
  selectionUnits: string[];

  stepTypes: ValueViewValue[];
  units: ValueViewValue[];

  items: any[];
  selectItems: any[];
  userInputs: any[];
}

export interface ValueViewValue {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-edit-step',
  templateUrl: 'edit-step.component.html',
  styleUrls: ['edit-step.component.css']
})
export class EditStepComponent implements OnInit {

  countryId: number = 0;
  countries: any[] = [];
  protectionTypeId: number = 0;
  protectionTypes: any[] = [];
  filingRouteId: number = 0;
  filingRoutes: any[] = [];
  technicalFieldId: number = 0;
  technicalFields: any[] = [];
  stepDurationData: any[] = [];
  cost: string = '';
  professional: string = '';
  groupName: string = '';
  overlapStep: boolean = false;
  userInputs: any[] = [];

  dirty: boolean = false;

  stepTypes: ValueViewValue[] = [
    { value: 'fixed', viewValue: 'Fixed' },
    { value: 'option', viewValue: 'Toggle' },
    { value: 'option2', viewValue: 'Toggle with Selection' },
    { value: 'fixedSelection', viewValue: 'Fixed with Selection' }
  ];

  public getStepTypeViewValue(value: string): string {
    let stepTypes = this.stepTypes.filter(x => x.value === value);
    if (stepTypes.length > 0) {
      return stepTypes[0].viewValue;
    }
    return "";
  }

  getDurationValue(step: any): any {
    if (step.type !== StepTypes.TOGGLE_SELECTION && step.type !== StepTypes.FIXED_SELECTION) {
      var val = step.duration.true.values[step.duration.true.selectedValueIndex];
      if (val) {
        return val.value;
      }
    }
    else {
      if (step.duration.false) {
        var val = step.duration.false.values[step.duration.true.selectedValueIndex].value;
        if (val) {
          return val.value;
        }
      }

    }

    return '';
  }

  formatCost(value: any): string {
    if (value && typeof value === 'object' && value.min !== undefined && value.max !== undefined) {
      // If it's an object with min and max, return the formatted range
      return `${value.min} - ${value.max}`;
    }
    // If it's a single number, return it as-is
    else if (typeof value === 'number' && value !== 0) {
      return value.toString();
    }
    return '';  // Fallback in case of undefined or unexpected format
  }

  getDurationGroupName(step: any): any {
    return step.groupName ? step.groupName : '';
  }

  getDurationUnit(step: any): any {
    if (step.type !== StepTypes.TOGGLE_SELECTION && step.type !== StepTypes.FIXED_SELECTION) {
      const val = step.duration.true.values[step.duration.true.selectedValueIndex];
      if (val) {
        return val.unit;
      }
    }
    else {
      if (step.duration.false) {
        const val = step.duration.false.values[step.duration.true.selectedValueIndex];
        if (val) {
          return val.unit;
        }
      }

    }

    return '';

  }

  units: ValueViewValue[] = [
    { value: 'days', viewValue: 'Day(s)' },
    { value: 'months', viewValue: 'Month(s)' },
    { value: 'years', viewValue: 'Year(s)' }
  ];

  constructor(public dialog: MatDialog, private rouseService: RouseConfigService) { }

  ngOnInit() {
    this.initialize();
  }

  async initialize(): Promise<void> {
    this.countries = await this.rouseService.getCountries();
    if (this.countries.length > 0) {
      this.countryId = this.countries[0].id;
      //this.technicalFields = await this.rouseService.getAllTechnicalFields();
      //if (this.technicalFields.length > 0) {
      //  this.technicalFieldId = this.technicalFields[0].id;
      //}
      await this.loadCountryData();
      this.userInputs = await this.rouseService.getUserInputs();
    }
  }

  async loadCountryData(): Promise<void> {
    this.protectionTypeId = 0;
    this.filingRoutes = [];
    this.filingRouteId = 0;
    this.technicalFieldId = 0;
    this.technicalFields = [];
    this.stepDurationData = [];
    this.dirty = false;

    this.protectionTypes = await this.rouseService.getProtectionTypes(this.countryId);
    if (this.protectionTypes.length > 0) {
      this.protectionTypeId = this.protectionTypes[0].id;
      this.filingRoutes = await this.rouseService.getFilingRoutes(this.countryId, this.protectionTypeId);
      if (this.filingRoutes.length > 0) {
        this.filingRouteId = this.filingRoutes[0].id;
        this.technicalFields = await this.rouseService.getTechnicalFields(this.countryId, this.protectionTypeId, this.filingRouteId);
        if (this.technicalFields.length > 0) {
          this.technicalFieldId = this.technicalFields[0].id;
          this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
        }
      }
    }
  }

  async loadProtectionTypeData(): Promise<void> {
    this.filingRoutes = await this.rouseService.getFilingRoutes(this.countryId, this.protectionTypeId);
    if (this.filingRoutes.length > 0) {
      this.filingRouteId = this.filingRoutes[0].id;
      this.technicalFields = await this.rouseService.getTechnicalFields(this.countryId, this.protectionTypeId, this.filingRouteId);
      if (this.technicalFields.length > 0) {
        this.technicalFieldId = this.technicalFields[0].id;
        this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
      }
    }
    else {
      this.filingRouteId = 0;
    }
    this.dirty = false;
  }

  async loadFilingRouteData(): Promise<void> {
    this.technicalFields = await this.rouseService.getTechnicalFields(this.countryId, this.protectionTypeId, this.filingRouteId);
    if (this.technicalFields.length > 0) {
      this.technicalFieldId = this.technicalFields[0].id;
      this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
    }
    this.dirty = false;
  }

  async loadStepDuration(countryId: number, protectionTypeId: number, filingRouteId: number, technicalFieldId: number): Promise<any[]> {
    if (countryId !== 0 && protectionTypeId !== 0 && filingRouteId !== 0 && technicalFieldId !== 0) {
      return await this.rouseService.getStepDuration(countryId, protectionTypeId, filingRouteId, technicalFieldId);
    }
    return [];
  }

  async onCountryChanged(event: MatSelectChange): Promise<void> {
    this.countryId = event.value;
    await this.loadCountryData();
  }

  async onProtectionTypeChanged(event: MatSelectChange): Promise<void> {
    this.protectionTypeId = event.value;
    await this.loadProtectionTypeData();
  }

  async onFilingRouteChanged(event: MatSelectChange): Promise<void> {
    this.filingRouteId = event.value;
    await this.loadFilingRouteData();
  }

  async onTechnicalFieldChanged(event: MatSelectChange): Promise<void> {
    this.technicalFieldId = event.value;
    this.stepDurationData = await this.loadStepDuration(this.countryId, this.protectionTypeId, this.filingRouteId, this.technicalFieldId);
    this.dirty = false;
  }

  parseValue(value: string | number | { min: number | null, max: number | null }): { min: number, max: number } | number {
    if (value === null || value === undefined) {
      return 0;
    }
    // Case 1: If it's a single number, return the number itself
    if (typeof value === 'number') {
      return value;
    }

    // Case 2: If it's an object with min and max, handle the range
    if (typeof value === 'object' && value !== null && 'min' in value && 'max' in value) {
      const { min, max } = value;

      // Check if either min or max is null, and return 0 in that case
      if (min === null || max === null) {
        return 0;
      }

      // Ensure both min and max are valid numbers
      if (typeof min === 'number' && typeof max === 'number') {
        return { min, max };
      }
    }

    // Case 3: If it's a string (which could represent a single value), try to parse it
    if (typeof value === 'string') {
      const parsedValue = parseFloat(value.trim());

      // If parsed value is a valid number, return it as a single value
      if (!isNaN(parsedValue)) {
        return parsedValue;
      }

      // If the string can't be parsed into a valid number, throw an error
      throw new Error(`Invalid value format: ${value}`);
    }

    // Default case: throw an error if the value is of an unknown type
    throw new Error(`Invalid value format: ${value}`);
  }

  async save() {
    try {
      // Iterate over each step to format `cost` and `professional`
      //for (let step of this.stepDurationData) {
      //  if (step.type !== StepTypes.TOGGLE_SELECTION && step.type !== StepTypes.FIXED_SELECTION) {
      //    // Parse the cost
      //    const parsedCost = this.parseValue(step.cost);
      //    step.cost = parsedCost; // Direct number or { min, max } object

      //    // Parse the professional
      //    const parsedProfessional = this.parseValue(step.professional);
      //    step.professional = parsedProfessional; // Direct number or { min, max } object
      //  }
      //}

      // Check if required fields are present
      if (this.countryId !== 0 && this.protectionTypeId !== 0 && this.filingRouteId !== 0 && this.technicalFieldId !== 0) {
        const stepDurationModel = {
          countryId: this.countryId,
          protectionTypeId: this.protectionTypeId,
          filingRouteId: this.filingRouteId,
          technicalFieldId: this.technicalFieldId,
          data: JSON.stringify(this.stepDurationData), // Serialize for saving
        };

        const ret = await this.rouseService.postStepDuration(stepDurationModel);
        if (ret === 'OK') {
          this.dirty = false;
        }
      }
    } catch (error) {
      console.error('Error saving step durations:', error.message);
    }
  }


  discard(): void {
    this.loadFilingRouteData();
  }

  addStep(): void {
    const items: ValueViewValue[] = this.buildControlItems("-2");
    const idx = this.stepDurationData.length.toString();
    let idxNum = parseInt(idx, 10);
    let allItems: ValueViewValue[] = this.buildControlItems(idx, true, idxNum);
    const selectItems = [];

    const dialogRef = this.dialog.open(StepDialog, {
      width: '900px',
      maxHeight: '90vh',
      data: {
        dialogTitle: 'Add new step',
        dialogMode: 'add',
        name: 'step',
        type: this.stepTypes[0].value,
        duration: 1,
        unit: 'months',
        stepTypes: this.stepTypes,
        units: this.units,
        enabledBy: "-1",
        items: items,
        selectItems: selectItems,
        userInput: this.userInputs,
        allItems: allItems,
        follows: "-1"
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      let selected: boolean = false;
      let duration: any = {};
      let userInput: any = {};
      let userInputs = [];

      for (let item of result.userInput) {
        userInputs.push({
          name: item.name,
          official: item.official,
          professional: item.professional,
          selected: item.selected,
          qty: item.qty,
          totalOfficial: item.totalOfficial,
          totalProfessional: item.totalProfessional,
          descriptionText: item.descriptionText
        });
      }

      userInput = {
        values: userInputs
      };

      // Handle the step types
      if (result.type === this.stepTypes[2].value || result.type === this.stepTypes[3].value) {
        let v = [];
        let n = [];
        let uv = [];
        let un = [];
        
        for (let item of result.selectItems) {
          // Assign the cost and professional values directly to each item
          v.push({
            value: item.duration,
            unit: item.unit,
            cost: item.cost,
            professional: item.professional,
          });
          n.push(item.name);
        }
        
        selected = result.type === this.stepTypes[3].value;

        duration = {
          true: {
            selectedValueIndex: 0,
            values: v,
            valueNames: n
          },
          false: {
            selectedValueIndex: 0,
            values: [
              {
                value: result.duration,
                unit: result.unit
              }
            ],
            valueNames: ['']
          }
        };

      } else if (result.type === this.stepTypes[1].value) {
        duration = {
          true: {
            selectedValueIndex: 0,
            values: [
              {
                value: result.duration,
                unit: result.unit
              }
            ]
          },
          false: {
            selectedValueIndex: 0,
            values: [
              {
                value: 0,
                unit: result.unit
              }
            ]
          }
        };
      } else {
        selected = true;
        duration = {
          true: {
            selectedValueIndex: 0,
            values: [
              {
                value: result.duration,
                unit: result.unit
              }
            ]
          }
        };
      }

      //// Handle cost (single value or range)
      //let cost = { min: 0, max: 0 }; // Default cost

      //if (typeof result.cost === "object" && result.cost.includes('-')) {
      //  // Split the cost into a range if it's in the form "min-max"
      //  const costRange = result.cost.split('-');
      //  cost = {
      //    min: parseFloat(costRange[0]) || 0,
      //    max: parseFloat(costRange[1]) || 0
      //  };
      //} else if (!isNaN(parseFloat(result.cost))) {
      //  // If cost is a single value, use the same value for min and max
      //  const parsedCost = parseFloat(result.cost);
      //  cost = {
      //    min: parsedCost || 0,
      //    max: parsedCost || 0
      //  };
      //}

      //// Handle professional (single value or range)
      //let professional = { min: 0, max: 0 }; // Default professional
      //if (typeof result.professional === "string" && result.professional.includes('-')) {
      //  // Split the professional fee into a range if it's in the form "min-max"
      //  const professionalRange = result.professional.split('-');
      //  professional = {
      //    min: parseFloat(professionalRange[0]) || 0,
      //    max: parseFloat(professionalRange[1]) || 0
      //  };
      //} else if (!isNaN(parseFloat(result.professional))) {
      //  // If professional fee is a single value, use the same value for min and max
      //  const parsedProfessional = parseFloat(result.professional);
      //  professional = {
      //    min: parsedProfessional || 0,
      //    max: parsedProfessional || 0
      //  };
      //}

      // Prepare the step object
      let step = {
        name: result.name,
        type: result.type,
        selected: selected,
        enabledBy: result.enabledBy,
        duration: duration,
        cost: result.cost,
        professional: result.professional,
        groupName: result.groupName,
        overlapStep: result.overlapStep,
        userInput: userInput,
        follows: result.follows
      };

      // Add the step to the step duration data array
      this.stepDurationData.push(step);

      // Mark the data as dirty for saving
      this.dirty = true;
    });

  }

  buildControlItems(ignoreIdx: string, ignoreType: boolean = false, maxIndex?: number): ValueViewValue[] {
    let items: ValueViewValue[] = [{
      value: "-1", viewValue: "---"
    }];

    for (let i in this.stepDurationData) {
      if (i !== ignoreIdx) {
        const iNum = parseInt(i, 10);
        if ((ignoreType || this.stepDurationData[i].type === 'option' || this.stepDurationData[i].type === 'option2') &&
          (maxIndex === undefined || iNum < maxIndex)) {
          items.push({ value: i, viewValue: this.stepDurationData[i].name });
        }
      }
    }

    return items;
  }


  editStep(idx: string, step: any): void {
    let dialogRef = null;
    let items: ValueViewValue[] = this.buildControlItems(idx); // Build control items for all relevant cases.
    let idxNum = parseInt(idx, 10);
    let allItems: ValueViewValue[] = this.buildControlItems(idx, true, idxNum);
    let userInputs = [];

    if (this.userInputs) {
      for (let i = 0; i < this.userInputs.length; i++) {
        let baseInput = this.userInputs[i];
        let matched = null;

        // Check if there's a matching item in step.userInput.values by name
        if (step.userInput && step.userInput.values) {
          matched = step.userInput.values.find(v => v.name === baseInput.name);
        }

        userInputs.push({
          name: baseInput.name,
          official: matched ? matched.official : baseInput.official,
          professional: matched ? matched.professional : baseInput.professional,
          selected: matched ? matched.selected : baseInput.selected,
          qty: matched ? matched.qty : baseInput.qty,
          totalOfficial: matched ? matched.totalOfficial : baseInput.totalOfficial,
          totalProfessional: matched ? matched.totalProfessional : baseInput.totalProfessional,
          descriptionText: baseInput.descriptionText
        });
      }
    }

    if (step.type === this.stepTypes[2].value || step.type === this.stepTypes[3].value) {
      let values = step.duration.true.values;
      let names = step.duration.true.valueNames;

      let selectItems = [];
      
      for (let i in values) {
        selectItems.push({
          name: names[i],
          duration: values[i].value,
          unit: values[i].unit,
          cost: values[i].cost ? values[i].cost : 0,
          professional: values[i].professional ? values[i].professional : 0,
          descriptionText: values[i].descriptionText
        });
      }

      dialogRef = this.dialog.open(StepDialog, {
        width: '900px',
        data: {
          dialogTitle: 'Edit step',
          dialogMode: 'edit',
          name: step.name,
          type: step.type,
          cost: step.cost,
          groupName: step.groupName,
          overlapStep: step.overlapStep,
          professional: step.professional,
          duration: step.duration.false.values[0].value,
          unit: step.duration.false.values[0].unit,
          stepTypes: this.stepTypes,
          units: this.units,
          enabledBy: step.enabledBy,
          items: items, // Pass the built items here.
          selectItems: selectItems,
          userInput: userInputs,
          allItems: allItems,
          follows: step.follows
        }
      });
    } else if (step.type === this.stepTypes[1].value) {
      dialogRef = this.dialog.open(StepDialog, {
        width: '900px',
        data: {
          dialogTitle: 'Edit step',
          dialogMode: 'edit',
          name: step.name,
          type: step.type,
          cost: step.cost,
          groupName: step.groupName,
          overlapStep: step.overlapStep,
          professional: step.professional,
          duration: step.duration.true.values[0].value,
          unit: step.duration.true.values[0].unit,
          stepTypes: this.stepTypes,
          units: this.units,
          enabledBy: step.enabledBy,
          items: items, // Pass the built items here.
          userInput: userInputs,
          allItems: allItems,
          follows: step.follows
        }
      });
    } else {
      dialogRef = this.dialog.open(StepDialog, {
        width: '900px',
        data: {
          dialogTitle: 'Edit step',
          dialogMode: 'edit',
          name: step.name,
          type: step.type,
          cost: step.cost,
          groupName: step.groupName,
          overlapStep: step.overlapStep,
          professional: step.professional,
          duration: step.duration.true.values[0].value,
          unit: step.duration.true.values[0].unit,
          stepTypes: this.stepTypes,
          units: this.units,
          enabledBy: step.enabledBy,
          items: items, // Pass the built items here.
          userInput: userInputs,
          allItems: allItems,
          follows: step.follows
        }
      });
    }

    dialogRef.afterClosed().subscribe(result => {
      // Handle the result as before.
      if (typeof result !== 'undefined') {
        step.name = result.name;
        step.cost = result.cost;
        step.professional = result.professional;
        step.groupName = result.groupName;
        step.overlapStep = result.overlapStep;
        step.enabledBy = result.enabledBy;
        step.follows = result.follows;

        if (step.type === this.stepTypes[0].value) {
          step.duration.true.values[0].value = result.duration;
          step.duration.true.values[0].unit = result.unit;
        }
        else if (step.type === this.stepTypes[1].value) {
          step.duration.true.values[0].value = result.duration;
          step.duration.true.values[0].unit = result.unit;
          step.enabledBy = result.enabledBy;
          step.follows = result.follows;
          let idx = this.stepDurationData.findIndex((v) => v === step);
          if (typeof idx !== 'undefined') {
            if (result.enabledBy > -1) {
              this.stepDurationData[result.enabledBy].enableStepIndex = idx;
            }
          } else {
            if (result.enabledBy > -1) {
              this.stepDurationData[result.enabledBy].enableStepIndex = -1;
            }
          }
        }
        else {
          let v = [];
          let n = [];
          let uv = [];
          let un = [];

          for (let item of result.selectItems) {
            v.push({
              value: item.duration,
              unit: item.unit,
              cost: item.cost,
              professional: item.professional
            });
            n.push(item.name);
          }

          

          step.duration = {
            true: {
              selectedValueIndex: 0,
              values: v,
              valueNames: n
            },
            false: {
              selectedValueIndex: 0,
              values: [
                {
                  value: result.duration,
                  unit: result.unit
                }
              ],
              valueNames: ['']
            }
          };

          
        }

        // Handle updated user inputs
        if (result.userInput && result.userInput.length > 0) {
          let updatedInputs = [];
          for (let i = 0; i < result.userInput.length; i++) {
            let item = result.userInput[i];
            updatedInputs.push({
              name: item.name,
              official: item.official,
              professional: item.professional,
              selected: typeof item.selected !== 'undefined' ? item.selected : false,
              qty: item.qty,
              totalOfficial: item.totalOfficial,
              totalProfessional: item.totalProfessional,
              descriptionText: item.descriptionText
            });
          }

          step.userInput = {
            values: updatedInputs
          };
        }

        this.dirty = true;
      }
    });
  }

  deleteStep(idx: number): void {
    this.openDeleteConfirmationDialog(idx);
  }

  moveStepUp(idx: number): void {
    if (idx > 0) {
      let step0 = this.stepDurationData[idx - 1];
      this.stepDurationData[idx - 1] = this.stepDurationData[idx];
      this.stepDurationData[idx] = step0;
      this.dirty = true;
    }
  }

  moveStepDown(idx: number): void {
    if (idx < this.stepDurationData.length - 1) {
      let step0 = this.stepDurationData[idx + 1];
      this.stepDurationData[idx + 1] = this.stepDurationData[idx];
      this.stepDurationData[idx] = step0;
      this.dirty = true;
    }
  }

  openDeleteConfirmationDialog(deleteIndex: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Are you sure you want to delete this step?"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.stepDurationData.splice(deleteIndex, 1);
        this.dirty = true;
      }
    });
  }
}
